import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

import { useHistory } from 'react-router-dom';
import { getPpBnCode, getPpClientId, track, useActions } from '@ttstr/utils';
import { hideFinisher } from '@ttstr/actions';

import {
  createPayPalOrder,
  updatePayPalShippingAddress,
  updatePayPalShippingOptions,
  checkoutPayPalOrder,
} from '@ttstr/api/cart';
import { useShopConfig } from '@ttstr/components/ShopConfig/ShopConfigContext';

const PayPalCheckout: React.FC = () => {
  const config = useShopConfig();
  const history = useHistory();
  const { hideFinisher } = useActions(mapDispatchToProps);

  const ppClientId = getPpClientId(config.payPal2?.clientId);
  const ppBnCode = getPpBnCode(config.payPal2?.bnCode);
  const ppEnableCheckout = Boolean(config.payPal2?.enableCheckout);
  if (!ppEnableCheckout || !ppClientId || !ppBnCode) {
    return null;
  }

  const createOrder = async (data: any, actions: any) => {
    try {
      const resp = await createPayPalOrder(true);
      track(resp.event_data);
      return resp.order_id;
    } catch (e) {
      // console.error(e);
    }
  };

  const onApprove = async (data: any, actions: any) => {
    // console.log({data, actions})
    let cart_token: any = null;
    try {
      const resp = await checkoutPayPalOrder(true);
      cart_token = resp.cart_token;
      track(resp.event_data);
    } catch (e) {
      // console.error(e);
    } finally {
      setTimeout(() => {
        hideFinisher();
        history.push(`/cart/${cart_token}/status`);
      }, 300);
    }
  };

  const onShippingOptionsChange = async (data: any, actions: any) => {
    // console.log({data, actions})
    try {
      const resp = await updatePayPalShippingOptions(true, data);
      // console.log({resp})
    } catch (e) {
      return actions.reject(data.errors.METHOD_UNAVAILABLE);
    }
  };

  const onShippingAddressChange = async (data: any, actions: any) => {
    // console.log({data, actions})
    try {
      const resp = await updatePayPalShippingAddress(true, data);
      // console.log({resp})
    } catch (e) {
      return actions.reject(data.errors.COUNTRY_ERROR);
    }
  };

  const onError = (err: Record<string, unknown>) => {
    // console.error(err);
  };

  return (
    <PayPalScriptProvider
      options={{
        clientId: ppClientId,
        dataPartnerAttributionId: ppBnCode,
        components: 'buttons',
        currency: 'EUR',
        disableFunding: 'sepa,card,credit,paylater,bancontact,blik,ideal',
        intent: 'capture',
        commit: true,
        // debug: true,
      }}
    >
      <PayPalButtons
        style={{ disableMaxWidth: true, label: 'checkout', borderRadius: 30, height: 48 }}
        createOrder={createOrder}
        onError={onError}
        onApprove={onApprove}
        onShippingOptionsChange={onShippingOptionsChange}
        onShippingAddressChange={onShippingAddressChange}
      />
    </PayPalScriptProvider>
  );
};

const mapDispatchToProps = {
  hideFinisher,
};

export default PayPalCheckout;
